module.exports = __webpack_public_path__ + "static/zs-svitavy-d058af4b8a3fc02518c4a38071e4021d.png";